// Chatwoot API — wraps /chatwoot/token and /chatwoot/send-message
// (ported from psychologist.js). token() returns {base_url, website_token,
// identifier_hash}.

import { api } from './client'
import type { ChatwootStatus } from '../types/api'

export const chatwootApi = {
  token: () =>
    api.get<{ base_url: string; website_token: string; identifier_hash: string }>('/chatwoot/token'),
  sendMessage: (payload: Record<string, unknown>) => api.post('/chatwoot/send-message', payload),
  // Support-conversation unread state (parent bd-eiw).
  conversationStatus: () => api.get<ChatwootStatus>('/chatwoot/conversation-status'),
  markRead: () => api.post('/chatwoot/mark-read'),
}
